import { Button } from '@teach/ui'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  page: number
  pages: number
  onPageChange: (page: number) => void
}

/** «‹ 2/7 ›» — та же подача, что у `AdminPagination`, но с явными подписями:
 *  кнопка-иконка без имени недостижима ни скринридером, ни тестом. */
export const HistoryPager = ({ page, pages, onPageChange }: Props) => {
  const m = useMessages(messages)
  if (pages <= 1) return null
  return (
    <div className="mt-2 flex items-center justify-center gap-2">
      <Button
        variant="outline"
        size="icon"
        className="h-8 w-8"
        aria-label={m.prevPage}
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <span className="text-sm text-muted-foreground">
        {page} / {pages}
      </span>
      <Button
        variant="outline"
        size="icon"
        className="h-8 w-8"
        aria-label={m.nextPage}
        disabled={page >= pages}
        onClick={() => onPageChange(page + 1)}
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  )
}
